import React, { useEffect } from "react";
import MEL8 from "../assets/MEL.8.jpg";
import MEL5 from "../assets/MEL.5.jpg";
import MEL7 from "../assets/MEL.7.jpg";
import "./about.css";

const About = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    document.querySelectorAll(".fade-in").forEach((el) => observer.observe(el));
  }, []);

  return (
    <section className="about-page">
      <div className="about-hero">
        <img src={MEL8} alt="Marie-Eve Leclerc" className="about-hero-image" />
      </div>

      <div className="about-main-wrapper">
        <div className="about-card fade-in left-image">
          <div className="about-image">
            <img src={MEL5} alt="Decorative MEL5" />
          </div>
          <div className="about-text">
            <h2>Behind the Work</h2>
            <p>
              My path to becoming a psychologist was not completely linear.
              Early in my career, I worked as an interventionist and clinical
              counsellor in shelters for women—primarily immigrants—who were
              survivors of family violence. I spent six years deeply engaged in
              crisis-intervention and trauma-related work with these women and
              their children. Those experiences profoundly shaped my clinical
              approach and laid the foundation that continues to guide my work
              today.
              <br />
              <br />
              As I expanded my understanding of trauma, I went on to work as a
              clinical counsellor in a federal facility for male offenders. By
              then, I had completed my undergraduate degree in Psychology at
              Concordia University and, through my clinical work, had become
              acutely aware of the far-reaching impacts of psychological trauma.
              This insight motivated me to pursue a research-based Master of
              Science (MSc) in Psychiatry at the Faculty of Medicine at McGill
              University, where my research focused on post-traumatic stress
              disorder. Following the completion of my MSc, I completed a Master
              of Arts (MA) and Doctorate (PhD) in Clinical Psychology at the
              University of Ottawa—a seven-year program that deepened my
              expertise in both clinical practice and research.
              <br />
              <br />
              My doctoral work focused on couple relationships and
              attachment—two areas I remain passionate about today. Throughout
              my doctoral training and during my residency at the Ottawa
              Institute of Cognitive Behavioural Therapy, I gained comprehensive
              experience in Dialectical Behaviour Therapy (DBT), both in
              individual and group settings—particularly in the treatment of
              borderline personality disorder—as well as in conducting
              psychodiagnostic and attention-deficit/hyperactivity disorder
              (ADHD) assessments in adults.
              <br />
              <br />
              Over the past 13 years, I have worked in a variety of clinical
              settings. This work has been supported by a total of 11 years of
              university training in psychology—academic and clinical
              experiences that continue to shape my approach.
            </p>
          </div>
        </div>

        <div className="about-card fade-in right-image">
          <div className="about-image">
            <img src={MEL7} alt="Decorative MEL7" />
          </div>
          <div className="about-text">
            <h2>My approach</h2>
            <p>
              My clinical approach is grounded in the scientist-practitioner
              model, integrating empirical research and clinical guidelines to
              provide thorough psychodiagnostic assessments and evidence-based
              treatments. Over the years, I’ve developed expertise in several
              areas, including differential diagnosis, ADHD, trauma,
              relationship and interpersonal difficulties, emotion regulation,
              borderline and other personality disorders, major life
              transitions, depression, anxiety, OCD and more.
              <br />
              <br />
              My therapeutic work is deeply rooted in attachment theory, and I
              approach both therapy and assessment from a culturally sensitive,
              trauma-informed, neurodiversity-affirming perspective, grounded in
              an awareness of intersectionality and an LGBTQIA+ affirming lens.
              <br />
              <br />
              At the heart of my practice are the values that matter most to me:
              authenticity, collaboration, non-judgment, warmth, transparency,
              and inclusivity. I aim to meet each person not just as a
              psychologist, but as a fellow human being—with respect, curiosity,
              and care.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
